import { Box } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { BatchParametersTableProps } from './Tables.types'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { format } from 'date-fns'
export const BatchParameterTable = ({
  data,
  isLoading,
  updateTableData,
  updateParametersData,
  isUploading,
}: BatchParametersTableProps) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'Work centre code',
        field: 'workCentreCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Batch grouping code',
        field: 'batchGroupingCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Batch minimum order quantity',
        field: 'batchMinimumOrderQuantity',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Batch minimum order increment',
        field: 'batchMinimumOrderIncrement',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Min batch production unit of measure code',
        field: 'MinBatchProductionUnitOfMeasureCode',
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        headerName: 'Valid from date',
        field: 'validFromDate',
        flex: 1,
        type: 'date',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
      {
        headerName: 'Valid to date',
        field: 'validToDate',
        flex: 1,
        type: 'date',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
    ],
    [data]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={updateParametersData}
        isUploading={isUploading}
        isSaving={false}
        checkBoxSelection={true}
        showTableToolBar={true}
        pinnedColumns={['workCentreCode', 'batchGroupingCode']}
        downloadFileName="BatchParameters"
      />
    </Box>
  )
}
